import { Link } from 'react-router-dom';
import Routes from '../configuration/routes/RouteList';
import { useAuthStore } from '../stores/AuthDataStore';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { auth } = useAuthStore();
  const version = auth?.version;

  return (
    <div className="footer">
      <div className="boxed-content">
        <span>© 2021 - {currentYear} </span>
        <span>Niuniu Media </span>
        <span>{version} </span>
        <span>
          <Link to={Routes.About}>About</Link>
        </span>
      </div>
    </div>
  );
};

export default Footer;
